<template>
  <AdminDashboard v-if="isAdmin" />
  <UserDashboard v-else-if="ready" />
</template>

<script>
import AdminDashboard from "./Dashboard.vue";
import UserDashboard from "./UserDashboard.vue";

export default {
  name: "DashboardEntry",
  components: {
    AdminDashboard,
    UserDashboard,
  },
  data() {
    return {
      ready: false,
      isAdmin: false,
    };
  },
  created() {
    const user = this.$store.getters.user;
    this.isAdmin = user?.role === "ADMIN";
    this.ready = true;
  },
};
</script>
